import { Row } from 'components/base';
import * as Card from 'components/card';
import { LinkButton } from 'components/input';
import React from 'react';
import { strings } from 'strings';

interface MeetingActionsCardProps {
  patientId: string;
}

export const MeetingActionsCard: React.FC<MeetingActionsCardProps> = ({ patientId }) => (
  <Card.BaseWrapper>
    <Row>
      <LinkButton
        text={strings.JoinMeeting}
        to={{
          screen: 'Patient',
          params: { screen: 'View', params: { id: patientId, screen: 'VideoConsult' } },
        }}
      />
    </Row>
  </Card.BaseWrapper>
);
